// ========================================
// PDP - Model Size Info on Media Gallery 4
// ========================================
window.toggleModelInfo = function (element) {
    let modelSizeText = element.querySelector('.model-size-info');
    let modelInfo = element.querySelector('.product-model-info');

    if (modelInfo.style.display === "none" || modelInfo.style.display === "") {
      modelInfo.style.display = "block";
      modelSizeText.style.display = "none";
    } else {
      modelInfo.style.display = "none";
      modelSizeText.style.display = "block";
    }
  };

  document.addEventListener("DOMContentLoaded", function () {
    let modelContainers = document.querySelectorAll('.model-product-info');

    modelContainers.forEach(function (modelContainer) {
      let modelSizeText = modelContainer.querySelector('.model-size-info');
      let modelInfo = modelContainer.querySelector('.product-model-info');

      const isMobile = window.innerWidth <= 768;

      if (isMobile) {
        // On Mobile: Show for 3 seconds, then hide
        modelInfo.style.display = "block";
        modelSizeText.style.display = "none";

        setTimeout(function () {
          modelInfo.style.display = "none";
          modelSizeText.style.display = "block";
        }, 3000);
      } else {
        // On Desktop: Show by default (but allow toggle too)
        modelInfo.style.display = "block";
        modelSizeText.style.display = "none";
      }
    });
  });


// ========================================
// PDP - Model Size Info on Media Gallery 3
// ========================================
// window.toggleModelInfo = function (element) {
//     let modelSizeText = element.querySelector('.model-size-info');
//     let modelInfo = element.querySelector('.product-model-info');

//     if (modelInfo.style.display === "none" || modelInfo.style.display === "") {
//       modelInfo.style.display = "block";
//       modelSizeText.style.display = "none";
//     } else {
//       modelInfo.style.display = "none";
//       modelSizeText.style.display = "block";
//     }
//   };

//   document.addEventListener("DOMContentLoaded", function () {
//     let modelContainers = document.querySelectorAll('.model-product-info');

//     modelContainers.forEach(function (modelContainer) {
//       let modelSizeText = modelContainer.querySelector('.model-size-info');
//       let modelInfo = modelContainer.querySelector('.product-model-info');

//       // Check screen width to determine mobile vs desktop
//       const isMobile = window.innerWidth <= 768;

//       if (isMobile) {
//         // On mobile: Show info for 3 seconds, then hide
//         modelInfo.style.display = "block";
//         modelSizeText.style.display = "none";

//         setTimeout(function () {
//           modelInfo.style.display = "none";
//           modelSizeText.style.display = "block";
//         }, 3000);
//       } else {
//         // On desktop: Hide by default
//         modelInfo.style.display = "none";
//         modelSizeText.style.display = "block";
//       }
//     });
//   });


// ========================================
// PDP - Model Size Info on Media Gallery 2
// ========================================
// window.toggleModelInfo = function (element) {
//     let modelSizeText = element.querySelector('.model-size-info');
//     let modelInfo = element.querySelector('.product-model-info');

//     if (modelInfo.style.display === "none" || modelInfo.style.display === "") {
//         modelInfo.style.display = "block";
//         modelSizeText.style.display = "none";
//     } else {
//         modelInfo.style.display = "none";
//         modelSizeText.style.display = "block";
//     }
// };

// Auto-show the model info for 3 seconds on page load, then hide it
// document.addEventListener("DOMContentLoaded", function () {
//     let modelContainers = document.querySelectorAll('.model-product-info');

//     modelContainers.forEach(function (modelContainer) {
//         let modelSizeText = modelContainer.querySelector('.model-size-info');
//         let modelInfo = modelContainer.querySelector('.product-model-info');

//         modelInfo.style.display = "block"; // Show Model Info
//         modelSizeText.style.display = "none"; // Hide 'Model Size' label initially

//         setTimeout(function () {
//             modelInfo.style.display = "none"; // Hide Model Info after 3 seconds
//             modelSizeText.style.display = "block"; // Show 'Model Size' label
//         }, 3000);
//     });
// });


// ========================================
// PDP - Model Size Info on Media Gallery 1
// ========================================
// window.toggleModelInfo = function (element) {
//     let modelSizeText = element.querySelector('.model-size-info');
//     let modelInfo = element.querySelector('.product-model-info');

//     if (modelInfo.style.display === "none" || modelInfo.style.display === "") {
//         modelInfo.style.display = "block";
//         modelSizeText.style.display = "none";
//     } else {
//         modelInfo.style.display = "none";
//         modelSizeText.style.display = "block";
//     }
// };


// window.toggleModelInfo = function toggleModelInfo(element) {
//     const infoParagraph = element.querySelector('.product-model-info');
//     if (infoParagraph) {
//         infoParagraph.classList.toggle('hidden');
//     }
// };


// ========================================
// ========================================
$(document).ready(function () {
    // Add your custom JavaScript code here
    console.log('Custom JavaScript is working!');

    // Upsell Popup on PDP
    $(".show_me_btn").click(function () {
        $(".upsell_popup").addClass("active");
        // alert("This is a test");
    });

    $(".popup_overlay").click(function () {
        $(".upsell_popup").removeClass("active");
    });

    // On Variant selection
    $(".up_variant select").on("change", function () {
        $("option:selected", this).attr("selected", !0).siblings().removeAttr("selected");
        var t = $(this).attr("data-id"),
         e = $("option:selected", this).attr("data-price"),
         o = $("option:selected", this).attr("data-cprice"),
         c = $("option:selected", this).val();
        $('.up_main_product_inner[data-productid="' + t + '"] .selected_product').val(c),
         $('.up_main_product_inner[data-productid="' + t + '"] .main_price').text(e),
         $('.up_main_product_inner[data-productid="' + t + '"] .compare_price').text(o);
    });

    $(".up_variant .selected_product").each(function () {
        $(this).change(function () {
         var t = $("input.selected_product:checkbox:checked").length;
         t >= 1 ? $(".add_up_btn").removeClass("disabled") : $(".add_up_btn").addClass("disabled");
        });
    });

    // Add items to the Cart using the Shopify Queue
    $(".add_up_btn").click(function (t) {
        t.preventDefault();
        (Shopify.queue = []);

        $(".up_variant .selected_product:checked").each(function () {
            var e = $(this).val();
            console.log(e);
            Shopify.queue.push({
                variantId: e,
                quantity: 1
            });
        });

        (Shopify.moveAlong = function () {
            if (Shopify.queue.length) {
                var e = Shopify.queue.shift(),
                o = "id=" + e.variantId + "&quantity=" + e.quantity;
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    dataType: "json",
                    data: o,
                    success: function (c) {
                        Shopify.moveAlong();
                    },
                    error: function () {
                        Shopify.queue.length && Shopify.moveAlong();
                    },
                });
            } else {
                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: !0 }));
                $(".add_up_btn").text("Added to cart");
                $(".upsell_popup").removeClass("active");
                $("body").addClass("drawer_open");
                $(".studio-cart-count").text(+$(".studio-cart-count").text() + 2);
                $("#sidebar-cart").attr("aria-hidden", "false");
                $("html").addClass("no-scroll lock");
                $(".PageOverlay").addClass("is-visible");
                // $('a.Header__Icon[data-drawer-id="sidebar-cart"]').trigger("click");
                $("a.header-cart-icon span.sr-only").trigger("click");
            }
        });
        Shopify.moveAlong();
    });

    // Klaviyo code from Old theme custom.js
    // $(document).on("click", ".ProductForm__Variants li.available", function () {
    //     setTimeout(function () {
    //         $("button.ProductForm__AddToCart, .ProductForm__QuantitySelector").show(), $(".custom_notify_me").removeClass("active"), $(".custom_notify_button").removeClass("active");
    //     }, 200),
    //         $("a.klaviyo-bis-trigger.Button").addClass("hide").hide();
    // });

});

// $(document).ready(function () {
//     checkIwishCount(10000);
//     jQuery("body").on("click",".iWishAdd, .iWishAddColl, .iwish-backdrop,.iwish_drawer_close", function() {
//          checkIwishCount(500);
//     });
//     function checkIwishCount(timer){
//       console.log("in chk");
//         setTimeout(function(){
//           var iwC1 = Number($('.iwish-counter').text());
//           console.log("iwC1: ",iwC1);
//           if(iwC1 > 0) {
//              $('.Header__IwDot').show();
//           }
//           else {
//              $('.Header__IwDot').hide();
//           }
//         },timer);
//     }

//     $('body').on('click','.iWishAdd',function(){
//       $('.iWishView').click();
//     })
//  });



    $(document).ready(function () {
        $(".cstm-accordian > a").on("click", function () {
        $(this).hasClass("active")
            ? ($(this).removeClass("active"), $(this).siblings(".content").slideUp(200), $(".cstm-accordian > a svg").removeClass("fa-minus").addClass("fa-plus"))
            : ($(".cstm-accordian > a svg").removeClass("fa-minus").addClass("fa-plus"),
                $(this).find("svg").removeClass("fa-plus").addClass("fa-minus"),
                $(".cstm-accordian > a").removeClass("active"),
                $(this).addClass("active"),
                $(".content").slideUp(200),
                $(this).siblings(".content").slideDown(200));
        });
            /*
            var intervall = setInterval(secondStuff, 1000);
            function secondStuff() {

            var mytextt =  $('.iwish_float_wrapper .iwish-float-icon').find('.iwish-counter').text();
            var maintext = $('.Header__Wrapper .Header__FlexItem .iWishView .iWishCount');
            var mainmenu = maintext.text();
            maintext.text(mytextt);
            console.log('work');

            }
            if(mytextt == mainmenu ){
                clearInterval(intervall);
            }
            */


        $('.accordion-item').first().find('.accordion-title').addClass('active');
        $(document).on('click', '.accordion-title', function(){
            if($(this).hasClass("active")){
            $(this).removeClass('active');
            }else{
            $('.accordion-title').removeClass('active');
            $(this).addClass('active');
            }
            if ($(".accordion-content").is(":visible")) {
                $(".accordion-content").slideUp(500);
            }
            if ($(this).next(".accordion-content").is(":visible")) {
                $(this).next(".accordion-content").slideUp(500);
            } else {
                $(this).next(".accordion-content").slideDown(500);
            }
        });





    }); // END $(document).ready(function () {



//  $(document).ready(function() {

//     console.log('Boost Filter JavaScript is working!');

//     const sortByLabel = $(".boost-sd__sorting-label"); // Replace .sort-by-class with the correct class or ID of your SORT BY label
//     if (sortByLabel.length) {
//         sortByLabel.text(sortByLabel.text().replace(":", ""));
//     }
// });

// $(document).ready(function() {
//     console.log('Boost Filter JavaScript is working!');
//     setTimeout(function() {
//         var $sortByLabel = $("span.boost-sd__sorting-label"); // Update selector based on inspection
//         if ($sortByLabel.length) {
//             // $sortByLabel.text($sortByLabel.text().replace(": ", ":::"));
//             $sortByLabel.text($sortByLabel.text().replace("Sort by: ", "Sort By "));
//         }
//     }, 1000); // Adjust the timing as needed
// });

// $(document).ready(function() {
//     console.log('Boost Filter JavaScript is working!');
//     $(".boost-sd__sorting-label").html("Sort By");
//     alert("Collection page...");
// });



